import { ChangeDetectionStrategy, Component, TemplateRef, ViewChild } from "@angular/core";
import { NzCardTabComponent } from "ng-zorro-antd/card";

@Component({
  selector: "ui-card-tab",
  exportAs: "uiCardTab",
  templateUrl: "card-tab.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiCardTabComponent extends NzCardTabComponent {
  @ViewChild(TemplateRef, { static: true }) public template!: TemplateRef<void>;
}
